import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Button, Stack } from '@mui/material'
import { endOfDay, startOfMonth } from 'date-fns'
import { FC, useState } from 'react'
import { DateRange } from 'react-day-picker'
import { toast } from 'react-toastify'
import { ApiPlayers } from '../../api'
import { dateFallback } from '../../utils/date'
import { DateRangePicker } from '../index'
import { IFinanceQuery } from './types'

interface ToolbarProps {
  playerId: string
  playerLogin: string
  query: IFinanceQuery
  onApply: () => void
  onResetFilters: () => void
  onRangeChange: (range: DateRange) => void
  range: DateRange
}

export const FinanceTableToolbar: FC<ToolbarProps> = ({
  playerId,
  playerLogin,
  query,
  onApply,
  onResetFilters,
  onRangeChange,
  range,
}) => {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    if (!query.from || !query.to) {
      toast.error('Выберите диапазон дат для экспорта')
      return
    }

    setIsExporting(true)
    try {
      const response = await ApiPlayers.exportXlsxFinanceByPlayerId({
        playerId,
        from: query.from,
        to: query.to,
      })
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${playerLogin}_финансы_${query.from}_${query.to}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      toast.success('Экспорт выполнен успешно')
    } catch (error) {
      toast.error(`Ошибка при экспорте: ${error}`)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Stack gap={2} direction="row" alignItems="center" flexWrap="wrap">
      <DateRangePicker
        from={range.from}
        to={range.to}
        onChangeRange={(rangeDate) => {
          onRangeChange({
            from: rangeDate?.from,
            to: rangeDate?.to,
          })
        }}
      />
      <Button size="small" variant="contained" onClick={onApply}>
        Применить
      </Button>
      <Button size="small" variant="outlined" onClick={onResetFilters}>
        Сбросить фильтры
      </Button>
      <Button
        size="small"
        color="primary"
        onClick={handleExport}
        startIcon={<FileDownloadIcon />}
        variant="contained"
        disabled={isExporting || !query.from || !query.to}>
        {isExporting ? 'Экспорт...' : 'Экспорт в .xlsx'}
      </Button>
    </Stack>
  )
}

// Хук для управления диапазоном дат
export const useDateRange = () => {
  const [range, setRange] = useState<DateRange>({
    from: dateFallback(startOfMonth(new Date())),
    to: dateFallback(endOfDay(new Date())),
  })

  return { range, setRange }
}
